import React, { useEffect } from "react";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
// styles
import styles from "./CircleBtnStyle";

const useStyles = makeStyles(styles);

export default function CircleBtn(props) {
  const classes = useStyles();
  return (
    <div className={classes.circleBtnContainer}>
      <KeyboardArrowUpIcon className={classes.icon} />
    </div>
  );
}
